import { FieldBase } from "./field-base";

export class TextareaField extends FieldBase<string> {
  controlType = "textarea";
  maxRows?: number;
  minRows?: number;

  constructor(options: {} = {}) {
    super(options);

    if (options["maxRows"]) {
      this.maxRows = options["maxRows"];
    }
    if (options["minRows"]) {
      this.minRows = options["minRows"];
    }
  }
}
